<template>
  <div 
    v-if="link"
    style="margin-top: 20px;"
  >
    <center>
      <v-btn
        :href="link.URL"
        :color="color ? color : 'black'"
        x-small
        elevation="0"
        outlined
      >
        {{ link.Name ? getTranslation(link.Name, locale) : getTranslation({ es: 'Ir a la web', en: 'Go to web'}, locale) }} 
      </v-btn>
    </center>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'
import axios from 'axios'
export default {
   props: {
      link: {
         type: Object,
        default: null,
      },
      locale: {
         type: String,
         required: true,
      },
    color: {
      type: String,
      default: null,
    },
   },
   data: () => ({
      loading: false,
   }),
   computed: {
      ...mapState('app', ['dtouchWorkspace']),
   },
   mounted () {
   },
   methods: {
      getTranslation (v, locale) {
         return utils.getTranslation(v, locale)
      },
   },
}
</script>

